<template>
  <v-card ref="search-table">
    <v-card-text>
      <v-data-table :items="addresses" :headers="headers" item-key="uniqueIdAddress" hide-actions>
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.address.street }}</td>
          <td
            class="text-xs-left"
          >{{ props.item.address.homeNumber }} {{ props.item.address.addition }}</td>
          <td class="text-xs-left">{{ props.item.address.postcode }}</td>
          <td class="text-xs-left">{{ props.item.address.municipality }}</td>
          <td class="text-xs-left">{{ props.item.address.city }}</td>
          <td class="text-xs-left">
            <v-btn icon flat color="primary" @click="load(props.item)">
              <v-icon class="pa-2">folder</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="back">Ga terug</v-btn>
    </v-card-actions>
  </v-card>
</template> 
<script>
import { mapActions } from "vuex";

export default {
  name: "AddressList",
  props: {
    addresses: Array,
    headers: [
      { text: "Straat", value: "address.street" },
      { text: "Huisnummer", value: "address.homeNumber" },
      { text: "Postcode", value: "address.postcode" },
      { text: "Gemeente", value: "address.municipality" },
      { text: "Plaatsnaam", value: "address.city" },
      { text: "Actie", value: "address.uniqueIdAddress" }
    ],
    enableBrowserBack: Boolean
  },
  methods: {
    ...mapActions(["loadAddress"]),
    load(address) {
      this.loadAddress(address);
      this.$router.push("/address");
    },
    back() {
      if (this.enableBrowserBack) {
        window.history.back();
      } else {
        this.$parent.addresses = [];
      }
    }
  }
};
</script>